<template>
      <div class="verification-selector">

          <div class="container container_40 verification-selector__item selector-item">
            <div class="selector-item__header">
              <span class="text_large">{{ i18n.kyc_general() }}</span>
              <md-icon>
                info
                <md-tooltip md-direction="top">{{ i18n.kyc_inv_tip() }}</md-tooltip>
              </md-icon>
            </div>
            <div class="selector-item__content">
              <md-icon class="md-size-5x md-medium-size-3x">person</md-icon>
            </div>
            <div class="btn-wrap margin-top">
              <md-button @click="setType(KYC_USER_TYPE.general)" class="btn md-primary">{{ i18n.kyc_submit() }}</md-button>
            </div>
          </div>

          <div class="container container_40 verification-selector__item selector-item">
            <div class="selector-item__header">
              <span class="text_large">{{ i18n.kyc_corporate() }}</span>
              <md-icon>
                info
                <md-tooltip md-direction="top">{{ i18n.kyc_corporate_tip() }}</md-tooltip>
              </md-icon>
            </div>

            <div class="selector-item__content">
              <md-icon class="md-size-5x md-medium-size-3x user-type-selector__user-type-icon">domain</md-icon>
            </div>
            <div class="btn-wrap margin-top">
              <md-button @click="setType(KYC_USER_TYPE.syndicate)"  class="btn md-primary">{{ i18n.kyc_submit() }}</md-button>
            </div>
          </div>

  </div>
</template>

<script>
  import { i18n } from '@js/i18n/index'
  import { KYC_USER_TYPE } from '@const'

  export default {
    name: 'user-type-selector',
    data () {
      return {
        KYC_USER_TYPE,
        i18n
      }
    },
    methods: {
      setType (type = undefined) {
        this.$emit('onVerification', type)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  @import './verification.scss';
</style>



// WEBPACK FOOTER //
// src/vue/app/verification/make/Verification.Selector.vue